export const isValidDate = (date: Date | string): boolean => {
  return isFinite(+(date instanceof Date ? date : new Date(date)));
};
